import { requireStates } from "util";
import { ConnectComponent2 } from "util";
import View from "./list/view";
import Presenter from "./list/presenter";

const initialStates = [
  {
    name: "app.registration.device",
    url: "/dispositivos",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        priority: 700,
        name: "Dispositivos",
        state: "app.registration.device"
      },
      authorization: () => true
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/device/index.js